App.Supplier = (function () {

  function initNew() {
    $("select[data-action=select-dropship-type]").on("change", function(e) {
      var selected = $(this).val();
      var disabled = selected != 'csv';
      $("[data-group=dropship-type-csv]").prop("disabled", disabled);

      if (selected == "printify") {
        $("[data-group=dropship-type-printify]").show();
        setPrintifyDefaults();
      } else {
        $("[data-group=dropship-type-printify]").hide();
      }
    });

    function setPrintifyDefaults() {
      var $inventoryImport = $("select[name='supplier[inventory_import_type]']");
      if ($inventoryImport.length && !$inventoryImport.val()) {
        $inventoryImport.val("printify");
      }
      var $sizeMap = $("select[name='supplier[size_map_type]']");
      if ($sizeMap.length && !$sizeMap.val()) {
        $sizeMap.val("printify");
      }
    }
    // initialize visibility based on current value
    $("select[data-action=select-dropship-type]").trigger("change");
    if (typeof Quill !== "undefined") {
      initGeneralInfoEditor();
    }
  }

  function initGeneralInfoEditor() {
    var $viewRow = $("#supplier-general-info-view-row");
    var $edit = $("#supplier-general-info-edit");
    var $editor = $("#general-info-editor");
    var $textarea = $("#supplier_general_information");

    if (!$editor.length || !$viewRow.length) return;

    var quill = new Quill($editor[0], {
      theme: "snow",
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, false] }],
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"],
          ["clean"]
        ]
      }
    });

    if ($textarea.val()) {
      quill.clipboard.dangerouslyPasteHTML($textarea.val());
    }

    quill.on("text-change", function() {
      $textarea.val(quill.root.innerHTML);
    });

    $(".general-info-edit-btn").on("click", function() {
      $viewRow.hide();
      $edit.show();
      quill.clipboard.dangerouslyPasteHTML($textarea.val() || "");
    });

    $("form").on("submit", function() {
      if ($edit.is(":visible")) {
        $textarea.val(quill.root.innerHTML);
      }
    });
  }

  function initEdit() {
    initNew();
  }

  return {
    initNew: initNew,
    initEdit: initEdit,
  }
})();

